export enum PrimarySubscriptionPlanEnum {
  A = 'PLAN_A',
  ATest = 'PLAN_A_TEST',
  B = 'PLAN_B',
  BTest = 'PLAN_B_TEST',
  C = 'PLAN_C',
  CTest = 'PLAN_C_TEST'
}

export enum PrimarySubscriptionPlanAccessAliasEnum {
  A = PrimarySubscriptionPlanEnum.A,
  B = PrimarySubscriptionPlanEnum.B,
  C = PrimarySubscriptionPlanEnum.C
}

export enum StripePurchaseEnum {
  Payment = 'payment',
  Subscription = 'subscription'
}

export enum StripePaymentStatusEnum {
  Failure = 'failure',
  Success = 'success'
}

export enum PrimarySubscriptionAccessActionEnum {
  CreateFarm = 'createFarm',
  ViewFarm = 'viewFarm',
  ViewSavedFarmsList = 'viewSavedFarmList'
}

export enum StoreProductEnum {
  Consumable,
  NonConsumable,
  Subscription
}

export enum PhoneAndEmailPurchaseActionRoles {
  Cancel = 'cancel',
  Change = 'change',
  Confirm = 'confirm',
  Store = 'store'
}
